module.exports = "#cv-list .ibox-content{\n        max-height: 295px;\n        overflow-y: auto;\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/maindashboard/available-cv/available-cv.component.css
// module id = ./src/app/modules/dashboard/components/maindashboard/available-cv/available-cv.component.css
// module chunks = main